import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { ProtectedRoute } from "./pages";
import {
  Gallery,
  AddGallery,
  EditGallery,
  ListPrestasi,
  AddPrestasi,
  EditPrestasi,
  ListKarya,
  AddKarya,
  EditKarya,
  ListVisiMisi,
  AddVisiMisi,
  EditVisiMisi,
  ListStrukturOrganisasi,
  AddStrukturOrganisasi,
  EditStrukturOrganisasi,
  ListSejarah,
  AddSejarah,
  EditSejarah,
  ListAlumni,
  AddAlumni,
  EditAlumni,
  ListTupoksi,
  AddTupoksi,
  EditTupoksi,
  ListLegalitas,
  AddLegalitas,
  EditLegalitas,
  ListKurikulum,
  AddKurikulum,
  EditKurikulum,
  ListSarana,
  AddSarana,
  EditSarana,
  ListProgram,
  AddProgram,
  EditProgram,
  ListBerita,
  AddBerita,
  EditBerita,
  ListIklan,
  AddIklan,
  EditIklan,
  ListKomunitas,
  AddKomunitas,
  EditKomunitas,
  SearchEngineSettings,
  ListKategori,
  AddKategori,
  EditKategori,
  ListMedsos,
  AddMedsos,
  EditMedsos,
  ListAgenda,
  AddAgenda,
  EditAgenda,
  ListKeasramaan,
  AddKeasramaan,
  EditKeasramaan,
  ListKesiswaan,
  AddKesiswaan,
  EditKesiswaan,
  ListHumas,
  AddHumas,
  EditHumas,
  ListTataUsaha,
  AddTataUsaha,
  EditTataUsaha,
} from "./admin/pages";
import LoginPage from "./admin/pages/LoginPage";

function App() {
  const Load = () => (
    <div className="h-screen w-full flex items-center justify-center">
      Loading...
    </div>
  );

  return (
    <Suspense fallback={<Load />}>
      <Routes>
        <Route path="/" element={<Navigate to="/adminlogin" replace />} />

        <Route path="/admincms" element={<ProtectedRoute />}>
          <Route
            index
            element={<Navigate to="/admincms/profile/visi" replace />}
          />

          <Route path="publikasi/gallery" element={<Gallery />} />
          <Route path="publikasi/gallery/add" element={<AddGallery />} />
          <Route path="publikasi/gallery/:id" element={<EditGallery />} />

          <Route path="publikasi/prestasi" element={<ListPrestasi />} />
          <Route path="publikasi/prestasi/add" element={<AddPrestasi />} />
          <Route path="publikasi/prestasi/:id" element={<EditPrestasi />} />

          <Route path="publikasi/karya" element={<ListKarya />} />
          <Route path="publikasi/karya/add" element={<AddKarya />} />
          <Route path="publikasi/karya/:id" element={<EditKarya />} />

          <Route path="profile/visi" element={<ListVisiMisi />} />
          <Route path="profile/visi/add" element={<AddVisiMisi />} />
          <Route path="profile/visi/edit/:id" element={<EditVisiMisi />} />

          <Route
            path="profile/struktur-organisasi"
            element={<ListStrukturOrganisasi />}
          />
          <Route
            path="profile/struktur-organisasi/add"
            element={<AddStrukturOrganisasi />}
          />
          <Route
            path="profile/struktur-organisasi/:id"
            element={<EditStrukturOrganisasi />}
          />

          <Route path="profile/sejarah" element={<ListSejarah />} />
          <Route path="profile/sejarah/add" element={<AddSejarah />} />
          <Route path="profile/sejarah/:id" element={<EditSejarah />} />

          <Route path="profile/alumni" element={<ListAlumni />} />
          <Route path="profile/alumni/add" element={<AddAlumni />} />
          <Route path="profile/alumni/:id" element={<EditAlumni />} />

          <Route path="profile/tupoksi" element={<ListTupoksi />} />
          <Route path="profile/tupoksi/add" element={<AddTupoksi />} />
          <Route path="profile/tupoksi/:id" element={<EditTupoksi />} />

          <Route path="profile/legalitas" element={<ListLegalitas />} />
          <Route path="profile/legalitas/add" element={<AddLegalitas />} />
          <Route path="profile/legalitas/:id" element={<EditLegalitas />} />

          <Route path="publikasi/sarana" element={<ListSarana />} />
          <Route path="publikasi/sarana/add" element={<AddSarana />} />
          <Route path="publikasi/sarana/:id" element={<EditSarana />} />

          <Route path="profile/kurikulum" element={<ListKurikulum />} />
          <Route path="profile/kurikulum/add" element={<AddKurikulum />} />
          <Route
            path="profile/kurikulum/edit/:id"
            element={<EditKurikulum />}
          />

          <Route path="publikasi/program" element={<ListProgram />} />
          <Route path="publikasi/program/add" element={<AddProgram />} />
          <Route path="publikasi/program/:id" element={<EditProgram />} />

          <Route path="publikasi/berita" element={<ListBerita />} />
          <Route path="publikasi/berita/add" element={<AddBerita />} />
          <Route path="publikasi/berita/:id" element={<EditBerita />} />

          <Route path="utils/kategori-berita" element={<ListKategori />} />
          <Route path="utils/kategori-berita/add" element={<AddKategori />} />
          <Route path="utils/kategori-berita/:id" element={<EditKategori />} />

          <Route path="utils/medsos" element={<ListMedsos />} />
          <Route path="utils/medsos/add" element={<AddMedsos />} />
          <Route path="utils/medsos/:id" element={<EditMedsos />} />

          <Route path="utils/iklan" element={<ListIklan />} />
          <Route path="utils/iklan/add" element={<AddIklan />} />
          <Route path="utils/iklan/:id" element={<EditIklan />} />

          <Route path="utils/searchengine" element={<SearchEngineSettings />} />

          <Route path="publikasi/agenda" element={<ListAgenda />} />
          <Route path="publikasi/agenda/add" element={<AddAgenda />} />
          <Route path="publikasi/agenda/:id" element={<EditAgenda />} />

          <Route path="publikasi/komunitas" element={<ListKomunitas />} />
          <Route path="publikasi/komunitas/add" element={<AddKomunitas />} />
          <Route path="publikasi/komunitas/:id" element={<EditKomunitas />} />

          <Route path="bidang/keasramaan" element={<ListKeasramaan />} />
          <Route path="bidang/keasramaan/add" element={<AddKeasramaan />} />
          <Route path="bidang/keasramaan/:id" element={<EditKeasramaan />} />

          <Route path="bidang/kesiswaan" element={<ListKesiswaan />} />
          <Route path="bidang/kesiswaan/add" element={<AddKesiswaan />} />
          <Route path="bidang/kesiswaan/:id" element={<EditKesiswaan />} />

          <Route path="bidang/humas" element={<ListHumas />} />
          <Route path="bidang/humas/add" element={<AddHumas />} />
          <Route path="bidang/humas/:id" element={<EditHumas />} />

          <Route path="bidang/tatausaha" element={<ListTataUsaha />} />
          <Route path="bidang/tatausaha/add" element={<AddTataUsaha />} />
          <Route path="bidang/tatausaha/:id" element={<EditTataUsaha />} />
        </Route>

        {/* <Route path="/adminlogin" element={<Login />} /> */}
        <Route path="/adminlogin" element={<LoginPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
